import React, { useEffect, useRef, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { convertToArabicNumbers, convertToNumbersInArabic, GetAppText, ValidationErrors } from "../../../utils";

import { ButtonComponent } from "../../components/ButtonComponent";
import { useParams } from 'react-router-dom';
import SvgComponent from "../../components/SvgComponent";
import { SeparatorComponent } from "../../components/Separator";
import { ProgressBar } from "../../components/ProgressBar";
import { DonationCard } from "../../components/DonationCard";
import { InputComponent } from "../../components/InputComponent";

import { apiRoutes } from "../../../apis/routes";
import { getRequest, postRequest } from "../../../apis/methods";
import { Loader } from "../../components/Loader";
import { useNavigate } from 'react-router-dom';
import { modalHandler } from "../../../store/slices/modalSlice";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleClick, handleSuccess } from '../../components/Toast/toastHelper';
import DonationModal from "../../components/DonationModal";
import { Image_URL } from "../../../utils/BaseUrl";
const ProjectDetails = () => {
    const settingData = useSelector((state) => state?.setting?.value);
  const language = useSelector((state) => state.language.value);
  const isOpen = useSelector((state) => state.openModel.value);
  const Info = useSelector((state) => state.info.value);
  const [loading,setLoading]=useState(false)
  const[data,setData]=useState('')
  const [addloading,setAddLoading]=useState(false)
  const [donateloading,setDonateLoading]=useState(false)
  const dispatch = useDispatch();
  const [price,setPrice]=useState("")
  const[similarData,setSimilarData]=useState('')
  const [isAddModal, setIsAddModal] = useState(false);
  const [limit, setLimit] = useState('');
  const[details,setDetails]=useState('')
  const[viewMore,setView]=useState(false)
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(()=>{
    fetchData()

  },[id])



  useEffect(()=>{
    if(isOpen?.type==="detailtoast"){
      handleSuccess(isOpen?.msg,language)
    }
    else if(isOpen?.type==="detailError"){
      handleClick(isOpen?.msg,language)
    }
    else if(isOpen==="detailpriceError"){
      handleClick(GetAppText("req_price"),language)
    }
    else if(isOpen?.type==="toast"){
      handleSuccess(isOpen?.msg,language)
    }
    else if(isOpen?.type==="share"){
      handleSuccess(isOpen?.msg,language)
    }
    else if(isOpen?.type==="toastError"){
      handleClick(isOpen?.msg,language)
    }
    else if(isOpen==="priceError"){
      handleClick(GetAppText("req_price"),language)
    }
  },[isOpen])
const [tagsName,setTags]=useState('')

  const fetchData = async () => {
 
    setLoading(true)
    try {
      const response = await getRequest(`${apiRoutes.get_projectDetails}?link=${id}`); // Replace with your endpoint
if(response.status==="success")
   { 
    setLoading(false)
  
    const projectData = response?.data?.project;
    if (response?.data?.project?.is_urgent === 1) {
      projectData.tags = [
     
        {
          id: "urgent", // Unique ID
          title: "Urgent",
          title_ar: "عاجل", // Arabic translation for "Urgent"
          slug: null,
          image: null,
          created_at: null,
          updated_at: null,
          deleted_at: null,
          pivot: null,
        },...projectData.tags,
      ];
      setTags(projectData.tags)
    }

else{
  setTags(projectData.tags)
}

    setData(response?.data?.project)
    if(response?.data?.project?.cart_item)
      { 
        setPrice(response?.data?.project?.cart_item?.price)}
    setSimilarData(response?.data?.similarProjects)
  
  }
  else{
    setLoading(false)
  }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching data:', error);
    }
  };


  const handleSubmit = async (item) => {
    // Prevent multiple submissions
  if (addloading) return; 
  // Prevent multiple submissions
  
  const data = {
    cart_type:"CART",
    is_edit:item?.cart_item?true:false,
    items: [
        {
            id:item?.id,
            type:"PROJECT",
            price: price
        }
    ]}



    // const data = {
    //   itemable_type: "project",
    // itemable_id: item?.id,
    //   price: price  
    // };
    setAddLoading(true)
  if(price){
    try {
      const response = await postRequest(apiRoutes.add_cart, data); // Replace with your endpoint
   
   
      if (response.status === "success") { 
        setAddLoading(false)
        let error = '';
        if (
          response?.message?.includes(ValidationErrors.addCartItem.added)
        ) {
          error = GetAppText('added_cart');
         
        } 
        else if (
          response?.message?.includes(ValidationErrors.addCartItem.updated)
        ) {
          error = GetAppText('updated_cart');
         
        } 

        dispatch(modalHandler({ type: "detailtoast", msg: error}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
     
          // setPrice("");
   
      } else {
        setAddLoading(false)
        let error=""
        if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.limit_error)
        ) {
          error = `${GetAppText('not_exceed_amount')}`;
     
        } 
       else if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.exceedGoalAmount)
        ) {
          error = `${GetAppText('limit_price_cart')} ${item?.remaining_goal_amount?.toLocaleString()}.`;
     
        } 
        else {
          // error = GetAppText('something_went_wrong');
          error= response?.data?.message
        }

        dispatch(modalHandler({ type: "detailError", msg: error}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
          // setPrice("");
       
      }
    } 
    catch (error) {
      console.error('Error fetching data:', error);
    } }
    else{
        setAddLoading(false)
     
        dispatch(modalHandler("detailpriceError"));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
  
    }
  
  };
  
  const handleDonate = async (item) => {
    // Prevent multiple submissions
  if (donateloading) return; 
  // Prevent multiple submissions
  
    // const data = {
    //   itemable_type: "project",
    // itemable_id: item?.id,
    //   price: price  
    // };
    const englishPhoneNumber = convertToArabicNumbers(price);

    const number = Number(englishPhoneNumber);

    const data = {
      cart_type:"DONATION",
      is_edit:item?.cart_item?true:false,
      items: [
          {
              id:item?.id,
              type:"PROJECT",
              price: number
          }
      ]}
  
    setDonateLoading(true)
  if(price){
    try {
      const response = await postRequest(apiRoutes.add_cart, data); // Replace with your endpoint
   
   
      if (response.status === "success") { 
        setDonateLoading(false)
   
        // dispatch(modalHandler({ type: "detailtoast", msg: response?.message}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
  
          setPrice("");
          navigate(`/checkout/donation`);
      } else {
        setDonateLoading(false)
        let error=""
        if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.limit_error)
        ) {
          error = `${GetAppText('not_exceed_amount')}`;
     
        } 
       else if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.exceedGoalAmount)
        ) {
          error = `${GetAppText('limit_price_cart')} ${item?.remaining_goal_amount?.toLocaleString()}.`;
     
        } 
        else if (
          response?.data?.message?.includes(ValidationErrors.addCartItem.lessAmount)
        ) {
          error = `${GetAppText('amount_less')}`;
     
        } 
        else {
          // error = GetAppText('something_went_wrong');
          error= response?.data?.message
        }   
        dispatch(modalHandler({ type: "detailError", msg: error}));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
          // setPrice("");
       
      }
    } 
    catch (error) {
      console.error('Error fetching data:', error);
    } }
    else{
      setDonateLoading(false)
     
        dispatch(modalHandler("detailpriceError"));
        setTimeout(()=>{
            dispatch(modalHandler(""));
          },[500])
  
    }
  
  };

      const handleProjectClick = (val) => {
      
        setDetails(val)
        setIsAddModal(true)
      dispatch(modalHandler("isDonate"));
        // navigate(`/donation-project/${id}`);
      };

      const ImageClick = (val) => {
   
        navigate(`/donation-project/${val?.slug}`);
      };

      const handleCartDetails=(items)=>{
      
        setDetails(items)
        setIsAddModal(true)
        dispatch(modalHandler(""));
        
        }

   


        const handle_share=()=>{
          const currentURL = window.location.href;
       
        const fullLink=`${currentURL}`
            // Copy the link to the clipboard
            navigator.clipboard.writeText(fullLink).then(() => {
              dispatch(modalHandler({type:"share",msg:GetAppText("link")}));
              setTimeout(()=>{
                dispatch(modalHandler(""));
              },100)
            });
        
        }
        
        const arabicDigits = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
        const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        
        const handleInputChange = (e) => {
          let value = e.target.value;
        
          // If language is Arabic, convert Arabic digits back to English for processing
          if (language === "_ar") {
            value = value
              .split("")
              .map((char) => {
                const index = arabicDigits.indexOf(char);
                return index > -1 ? englishDigits[index] : char;
              })
              .join("");
          }
        
          // Remove non-numeric characters and limit to 8 digits
          const numericValue = value.replace(/[^0-9]/g, "");
    
            if (language === "_ar") {
              // Convert English digits to Arabic digits for display
              const arabicValue = numericValue
                .split("")
                .map((digit) => arabicDigits[Number(digit)])
                .join("");
                console.log("arabicValue",arabicValue)
                setPrice(arabicValue);
            } 
            else {
              setPrice(numericValue);
            }
          
        };
        
        // const handlePriceChange = (e) => {
        //   let value = e.target.value;
        
        //   // If language is Arabic, convert Arabic digits back to English for processing
        //   // if (language === "_ar") {
        //   //   value = value
        //   //     .split("")
        //   //     .map((char) => {
        //   //       const index = arabicDigits.indexOf(char);
        //   //       return index > -1 ? englishDigits[index] : char;
        //   //     })
        //   //     .join("");
        //   // }
        
        //   // Allow numeric characters and a single decimal point, limit to 8 digits before the decimal
        //   const numericValue = value
        //   // .replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");
        
        //   // Restrict to maximum 8 digits before the decimal point
        //   const parts = numericValue.split(".");
        //   if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);
      
        //   // Limit to 2 digits after the decimal
        // if (parts.length > 1) {
        //   parts[1] = parts[1].slice(0, 2);
        // }
        
        //   const formattedValue = parts.join(".");
        
        //   // if (language === "_ar") {
        //   //   // Convert English digits to Arabic digits for display
        //   //   const arabicValue = formattedValue
        //   //     .split("")
        //   //     .map((digit) => (digit === "." ? "." : arabicDigits[Number(digit)]))
        //   //     .join("");
        
        //   //   setPrice(arabicValue);
        //   // } else {
        //     setPrice(formattedValue);
        //   // }
        // };


// const handlePriceChange = (e) => {
//   let value = e.target.value;

//   // Convert Arabic-Indic digits (٠١٢٣٤٥٦٧٨٩) to English digits (0–9)
//   const arabicToEnglishMap = {
//     "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
//     "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9"
//   };
//   value = value.replace(/[٠-٩]/g, d => arabicToEnglishMap[d]);

//   // Allow numeric characters and a single decimal point
//   let numericValue = value.replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");

//   // Restrict to max 8 digits before decimal
//   const parts = numericValue.split(".");
//   if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);

//   // Limit to 2 digits after the decimal
//   if (parts.length > 1) {
//     parts[1] = parts[1].slice(0, 2);
//   }

//   const formattedValue = parts.join(".");

//   // Set the final value
//   setPrice(formattedValue);
// };

const handlePriceChange = (e) => {
  let value = e.target.value;

  // ✅ Convert Arabic (٠١٢٣٤٥٦٧٨٩) and Urdu (۰۱۲۳۴۵۶۷۸۹) digits to English (0–9)
  const digitMap = {
    // Arabic-Indic
    "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
    "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
    // Urdu (Eastern Arabic-Indic)
    "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
    "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9"
  };

  // Replace all Arabic/Urdu digits with English digits
  value = value.replace(/[٠-٩۰-۹]/g, d => digitMap[d]);

  // ✅ Allow only numbers and a single decimal point
  let numericValue = value.replace(/[^0-9.]/g, "").replace(/(\.)(?=.*\.)/g, "");

  // ✅ Restrict to max 8 digits before decimal
  const parts = numericValue.split(".");
  if (parts[0].length > 8) parts[0] = parts[0].slice(0, 8);

  // ✅ Limit to 2 digits after the decimal
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2);
  }

  const formattedValue = parts.join(".");

  // ✅ Update state
  setPrice(formattedValue);
};

 const [isOverflowing, setIsOverflowing] = useState(false);
  // const [viewMore, setViewMore] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const el = textRef.current;
      // Compare scrollHeight with clientHeight
      if (el.scrollHeight > el.clientHeight) {
        setIsOverflowing(true);
      }
    }
  }, [data, language]);



  return (
    <>
 <ToastContainer />
    <div className="site-container site-container--narrow py-12 space-y-12">
           
{  loading?    
<div className="flex justify-center items-center h-[540px]">
      <Loader/>
      </div>:
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-start mx-auto w-full max-w-[1120px]">
<div className="w-full">
<img 

src={`${Image_URL}${data?.image}`}
className="block w-full aspect-[4/3] object-cover rounded-lg bg-gray-100" alt="logo" />
        {/* {
          data?.media?.map((item)=>(
            <img src={item?.thumbnail} className={`object-cover  ${data?.media?.length===1?"rounded-lg  h-[725px]":""}`} alt="logo" />
          ))
        } */}
</div>

        <div className="w-full min-w-0 text-primary space-y-5">
          <div
            className={`flex flex-row ${
              language === "_ar" ? "flex-row-reverse space-x-reverse " : ""
            } items-center justify-between space-x-2 `}
          >
            <h1 
             dir={language === "_ar" ? "rtl" : "ltr"}
            className="font-extrabold md:text-F24 line-clamp-1 text-F20 ">{ language === "_ar" ?data?.title_ar :data?.title}</h1>
            <ButtonComponent
             onClick={()=>{handle_share()}}
             tooltip={GetAppText("link_share")}
              title={GetAppText("sharing")}
              svg={
                <SvgComponent
                  name={"ShareSvg"}
                  className={"w-4 h-4"}
                  stroke={"black"}
                  fill={"none"}
                />
              }
              styles={"!py-2 !px-3 !text-black !w-fit !text-F16"}
              type="secondary_transparent"
            />
          </div>
          <div 
              ref={textRef}
          className={`font-normal  ${language === "_ar" ?"text-right":"text-left"}  text-F16
          sm:line-clamp-none ${viewMore?'line-clamp-none ':'line-clamp-3 '}
          `}
           dangerouslySetInnerHTML={{ __html:language === "_ar" ?data?.description_ar :data?.description }}>
      
            {/* {language === "_ar" ?data?.description_ar :data?.description} */}
            </div>
                 {isOverflowing && 
                 <p  onClick={() => setView(!viewMore)}
                  className="sm:hidden !font-bold block !-mt-0 cursor-pointer" dir={language === "_ar" ? "rtl" : "ltr"}>
                  {viewMore ?language === "_ar" ?'عرض أقل ...': 'View less...' : language === "_ar" ?'عرض المزيد ...': 'View more...'}
                  {/* {language === "_ar" ?'عرض المزيد ...': 'View more...'} */}
                  </p>}
            {/* <div className={`${language === "_ar" ?"text-right":"text-left"} bg-white p-6 flex-row-reverse rounded-xl`} 
           dangerouslySetInnerHTML={{ __html: language === "_ar" ? data?.value_ar:data?.value }}> */}
          <div
            className={`flex  ${
              language === "_ar" ? " flex-row-reverse  space-x-reverse" : ""
            } space-x-3 `}
          >
         {/* { data?.is_urgent===1 &&  <ButtonComponent
              title={GetAppText("urgent")}
              styles={"!py-1.5 !px-3 !h-8 !text-F14 !rounded-[4px] !border-0 !  "}
              type="primary"
            />} */}
<div className={`flex-wrap  ${language === "_ar" ?"justify-end flex-row-reverse":""}  flex gap-3`}>
{tagsName.length>0 && 
tagsName?.map((item,index)=>(
<div key={index} className={`!py-1.5 !px-3 !text-F14  ${item.title === "Urgent" ?"bg-errorColor uppercase text-white":"!text-secondaryTextColor !bg-btn_gray"} !rounded-[4px] !border-0 `}>
{language === "_ar" ?item.title_ar:item.title}
</div>
))
}
</div>
            {/* <ButtonComponent
              title={GetAppText("zakat")}
              styles={
                "!py-1.5 !px-3 !text-F14 !bg-btn_gray !rounded-[4px] !border-0 !text-secondaryTextColor"
              }
              type="primary"
            />
            <ButtonComponent
              title={GetAppText("close_target")}
              styles={
                "!py-1.5 !px-3 !text-F14 !bg-btn_gray !rounded-[4px] !border-0 !text-secondaryTextColor"
              }
              type="primary"
            /> */}
          </div>
          <SeparatorComponent className={"!border-borderSecondaryColor !my-6"} />
          <div
            className={`flex sm:flex-nowrap flex-wrap  ${
              language === "_ar" ? "flex-row-reverse  sm:space-x-reverse" : ""
            } gap-3`}
          >
           
        {data?.end_date&&    <div  className="bg-btn_gray sm:w-full w-[140px] rounded-md p-4 flex flex-col items-center ">
          <div className="md:space-y-3 space-y-2">
                <div
                  className={` flex items-center justify-center ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } space-x-2`}
                >
                  <SvgComponent
                    name={"Clock"}
                    className={"w-5 h-5"}
                    stroke={"#999999"}
                    fill={"none"}
                  />
                  <h2 className={`text-secondaryTextColor line-clamp-1 ${
                    language === "_ar"
                      ? "text-right"
                      : ""
                  } text-F14  font-semibold `}>
                    {GetAppText("remain_time")}
                  </h2>
                </div>
                <h2
                  className={`flex items-center justify-center ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } text-black text-F14 font-bold `}
                >
                 {data?.days_left} {GetAppText("day")}
                </h2>
              </div>
              </div>}
              <div  className="bg-btn_gray sm:w-full  w-[140px] rounded-md   p-4 flex flex-col items-center  ">
                <div className="md:space-y-3 space-y-2">
                <div
                  className={` flex  items-center justify-center ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } space-x-2`}
                >
                  <SvgComponent
                    name={"Block"}
                    className={"w-5 h-5"}
                    stroke={"#999999"}
                    fill={"none"}
                  />
                  <h2 className={`text-secondaryTextColor ${
                    language === "_ar"
                      ? "text-right"
                      : ""
                  }  text-F14 font-semibold `}>
                    {GetAppText("domain")}{" "}
                  </h2>
                </div>
                <h2
                  className={`flex items-center justify-center ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } text-black text-F14 font-bold  text-center`}
                >
                  {/* { language === "_ar"?data?.category?.title_ar:data?.category?.title} */}
                  {data?.category? language === "_ar"?data?.category?.title_ar:data?.category?.title:`${language==='_ar'?'لا يوجد':'N/A'}`}
                </h2>
                </div>
              </div>
              <div  className="bg-btn_gray sm:w-full  w-[140px] rounded-md text-center p-4  flex flex-col items-center">
                <div className="md:space-y-3 space-y-2">
                <div
                  className={` flex items-center justify-center ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } space-x-2`}
                >
                  <SvgComponent
                    name={"Donation"}
                    className={"w-5 h-5"}
                    stroke={"#999999"}
                    fill={"none"}
                  />
                  <h2 className={`text-secondaryTextColor ${
                    language === "_ar"
                      ? "text-right"
                      : ""
                  }  text-F14 font-semibold `}>
             {GetAppText("donated")}
                  </h2>
                </div>
                <h2
                  className={`flex items-center justify-center space-x-1 ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } text-black text-F14 font-bold `}
                ><div>
              {data?.donated_amount?.toLocaleString()}</div> <div> {GetAppText("bhd")}</div>
                </h2>
                </div>
              </div>
           
          </div>
   {  data?.goal_amount || data?.end_date?     <ProgressBar value={data?.goal_percentage} progressStyle={"!p-1.5"} /> :""}
          <div className={`flex ${language==="_ar"?"":"flex-row-reverse"} justify-between  items-center sm:pb-2`}>
      {  data?.goal_amount ?     <>
            <div>
              <h2 className={`text-black text-F14 ${
                    language === "_ar"
                      ?"text-right" :""} font-bold `}>
                {GetAppText("goal")}
              </h2>
              <h2
              className={`flex items-center space-x-1 ${
                language === "_ar"
                  ? "flex-row-reverse  space-x-reverse"
                  : ""
              } text-secondaryTextColor text-F14  font-semibold `}
              // className="text-secondaryTextColor text-F14 font-semibold "
              >
             <div> {data?.goal_amount?.toLocaleString()} </div> <div> {GetAppText("bhd")}</div>
              </h2>
            </div>

            <div>
              <h2 className={`text-black text-F14 ${
                    language === "_ar"
                      ?"text-right" :""} font-bold `}>
                {GetAppText("residual")}
              </h2>
              <h2
               className={`flex items-center space-x-1 ${
                language === "_ar"
                  ? "flex-row-reverse  space-x-reverse"
                  : ""
              } text-secondaryTextColor text-F14  font-semibold `}
              >
             <div> {data?.remaining_goal_amount?.toLocaleString()}</div><div> {GetAppText("bhd")}</div> 
              </h2>
            </div>
            </>:""}
            {/* <div>
              <h2 className={`text-black text-F14 ${
                    language === "_ar"
                      ?"text-right" :""} font-bold `}>
                {GetAppText("donated")}
              </h2>
              <h2      className={`flex items-center space-x-1 ${
                    language === "_ar"
                      ? "flex-row-reverse  space-x-reverse"
                      : ""
                  } text-secondaryTextColor text-F14  font-semibold `} >
              <div>  {data?.donated_amount?.toLocaleString()}</div> <div> {GetAppText("bhd")}</div>
              </h2>
            </div> */}
          </div>
      {data?.goal_percentage<100 &&   
      <div className={`flex flex-row     ${language === "_ar" ? "flex-row-reverse" : ""} 
      sm:gap-6 gap-3 sm:pt-5`}>
          <div className=" -lg:w-[55%] -md:w-[75%] w-full">
            <InputComponent 
           type={language === "_ar"?"text":"text"}
              value={price}
            //  value={language==="_ar"?convertToNumbersInArabic(price):convertToArabicNumbers(price)}
            title="donation_amount"
            // value={price} 
            //  onChange={(e) => setPrice(e.target.value)}
            onChange={(e)=>{  e.stopPropagation();  handlePriceChange(e)}}
            // onChange={handleInputChange}
            />
            </div>
            <div className="flex  items-center gap-2   -lg:w-[45%] -md:w-[35%] -sm:w-[60%] lg:flex-nowrap md:flex-wrap flex-nowrap">
            {/* <ButtonComponent
            onClick={()=>{handleSubmit(data)}}
            loading={addloading}
            disabled={donateloading ||addloading}
              styles={"!text-F18 !w-full  !px-1 !py-2"}
              type="primary"
              title={GetAppText("add_cart")}
            /> */}
            <ButtonComponent
            onClick={()=>{handleDonate(data)}}
            loading={donateloading}
            disabled={donateloading || addloading}
              isSvg
              styles={`!text-F18 ${donateloading?"sm:!px-[28px]":"sm:!px-14 !px-6"}  sm:!w-fit whitespace-nowrap !w-full  !py-2  `}
              title={GetAppText("donate_now")}
            />
            </div>
           
          </div>}
        </div>
      </div>
      }
{      <div className="mx-auto w-full max-w-[1120px]">
  {similarData.length>0 && <div className="sm:block hidden">
        <SeparatorComponent  />
        </div>}
      {similarData.length>0 &&  <div className={"space-y-8 sm:pt-4"}>
          <h1
            className={`font-bold text-F27 text-primary flex ${
              language === "_ar" ? "flex-row-reverse" : ""
            } `}
          >
            {GetAppText("similar_projects")}
          </h1>
          <div
            dir={language === "_ar" ? "rtl" : "ltr"}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
          >
         {loading?    <div className="flex justify-center items-center h-[440px]">
      <Loader/>
      </div>:similarData.length>0 ?
      similarData?.map((item,index)=>(
           <DonationCard fluid data={item} onClick={()=>{handleProjectClick(item)}} onImageClick={()=>{ImageClick(item)}}  onCartClick={()=>{handleCartDetails(item)}}   key={index}/>
         )):
         (!loading && <div className="flex w-full h-[350px]  justify-center text-F20 font-semibold items-center">
          {GetAppText("no_data")}
           </div>)
           }
          </div>
        </div>
}
      </div>}
     

    </div>
    {/* {isAddModal&& <DonationModal isAddModal={isAddModal} details={details} setIsAddModal={setIsAddModal}/>} */}
    </>
  );
};

export default ProjectDetails;
